const visaList = [
    {
        type:'旅游B1',
        name:'B1 - Tourist (Visa On Arrival)',
        desc:'无需账户'
    },
    {
        type:'旅游C1',
        name:'C1 - Tourist Single Entry Visitor Visa -  60 Days',
        desc:'普通账户'
    },
    {
        type:'商务C2',
        name:'C2 - Business Single Entry Visa',
        desc:'普通账户'
    },
    {
        type:'C6',
        name:'C6 - Social, Humanitarian and Volunteering',
        desc:'担保账户'
    },
    {
        type:'C9',
        name:'C9 - Short Course',
        desc:'担保账户'
    },
    {
        type:'C11',
        name:'C11 - Exhibitor',
        desc:'担保账户'
    },
    {
        type:'投资C12',
        name:'C12 - Pre-Investment',
        desc:'普通账户'
    },
    {
        type:'C16',
        name:'C16 - Counseling and Training on Industrial Technology Innovation',
        desc:'担保账户'
    },
    {
        type:'C13',
        name:'C13 - Join Vessel',
        desc:'担保账户'
    },
    {
        type:'C17',
        name:'C17 - Audit, Quality Control, or Inspection at Company Branches in Indonesia',
        desc:'担保账户'
    },
    {
        type:'C19',
        name:'C19 - After Sales Service',
        desc:'担保账户'
    },
    {
        type:'C20',
        name:'C20 - Install and Repair Machines',
        desc:'担保账户'
    },
    {
        type:'C18',
        name:'C18 - Work Trial',
        desc:'担保账户'
    },
    {
        type:'商务D2-1年',
        name:'D2 - Business Multiple Entry Visa (1 Years)',
        desc:'普通账户'
    },
    {
        type:'商务D2-2年',
        name:'D2 - Business Multiple Entry Visa (2 Years)',
        desc:'普通账户'
    },
    {
        type:'投资D12-1年',
        name:'D12 - Pre-Investment Multiple Entry Visa (1 Years)',
        desc:'普通账户'
    },
    {
        type:'投资D12-2年',
        name:'D12 - Pre-Investment Multiple Entry Visa (2 Years)',
        desc:'普通账户'
    },
]
export const getVisaType = (type) => {
    return visaList.find(item => item.type === type) || {}
}